export default async function DeleteWorkOrder(id=0) {
    let url = window.RealestateService+  `/api/WorkOrder/DeleteWorkOrder?id=${id}`
    let head = {
         "content-type":"application/json",
        "accept":"*/*",
        "Authorization":window.token
    }
    let response = await fetch(url, {
        method:"DELETE",
        headers:head,
        // body:JSON.stringify(sendForm)
    }).then(res=>res.json()).catch(res=>res)

    return response
}